const convertSlugToUrl = (slug) => {
  return `${process.env.REACT_APP_YALABID_URL}/video/${slug}`;
};
export default convertSlugToUrl;
